import axiosInstance from "./AxiosInstance";
import config from "../config";

export const createChatRoom = (businessId) => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.createChatRoom(businessId),
		method: "post",
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
};

export const getRoomList = (userType) => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.getRoomList(userType),
		method: "get",
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
};
export const getChatHistory = (roomId) => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.getChatHistory(roomId),
		method: "get",
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
};
export const getUnseenChatCount = () => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.unseenMessage,
		method: "get",
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
};
